module.exports = __webpack_public_path__ + "img/empty_2.465c6601.png";